import React from 'react';
import { Box, Button, Container, SvgIcon, Typography, Link as LinkMUI } from '@material-ui/core'
import { Link } from 'react-router-dom'

const Title = ({ children }) => (
  <Typography variant="h5" style={{ marginTop: "1em" }}>
    {children}
  </Typography>
)
const Paragraph = ({ children }) => (
  <Typography variant="body1" style={{ marginTop: "0.8em" }}>
    {children}
  </Typography>
)

export const Intro = () => {
  return (
    <>
      <Container maxWidth="md">
        <Box mt={3}>
          <Box mb={2} display='flex' justifyContent='space-between' alignItems='center'>
            <Box display='flex' alignItems='center'>
              <Box mr={1}>
                <SvgIcon component="object">
                  <embed type="image/svg+xml" src="/favicon.svg" width="24"/>
                </SvgIcon>
              </Box>
              <Typography variant="h3">
                <LinkMUI href="https://medevio.cz/" underline="hover" color="textPrimary">
                  MEDEVIO
                </LinkMUI>
              </Typography>
            </Box>
            <Box>
              <Button component={Link} to="/form" color="primary" variant="contained"
                      style={{
                        marginLeft: "0.5em",
                        padding: "0.8em",
                        borderRadius: "1em",
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}>
                Vyplnit průzkum
              </Button>
            </Box>
          </Box>
          <Box mt={2}>
            <Typography variant="h3">
              Celostátní průzkum příznaků a potíží v souvislosti s proděláním nemoci COVID-19
            </Typography>
          </Box>
          <Title>
            Pro koho je tento průzkum určen?
          </Title>
          <Paragraph>
            Pro všechny, kteří v prodělali či prodělávají nemoc COVID-19 (pozitivní PCR test) a jsou ochotni pomoci se
            sledováním dlouhodobých příznaků a následků tohoto onemocnění. Dotazník můžete vyplnit i pokud jste
            prodělal/a bezpříznakový průběh onemocnění COVID-19.
          </Paragraph>

          <Title>
            Co získám výměnou za svůj čas?
          </Title>
          <Paragraph>
            Vašich necelých 10 minut přispěje k celostátnímu průzkumu této nemoci a lepšímu pochopení jejích dlouhodobých
            dopadů na zdraví obyvatel Česka.
          </Paragraph>
          <Title>
            Je dotazník anonymní?
          </Title>
          <Paragraph>
            Dotazník je možné vyplnit anonymně pouze s vyplněním kontaktního e-mailu. Na ten vám můžeme v budoucnosti
            zaslat návazný dotazník.
          </Paragraph>


          <Box width={{ sm: '50%' }} mt={3}>
            <Button component={Link} to="/form" color="primary" variant="contained" fullWidth
                    style={{ padding: "1em", borderRadius: "1em" }}>
              Vyplnit průzkum
            </Button>
            <Typography variant='body2' style={{ fontStyle: "italic", marginTop: "0.8em" }}>
              Vyplnění zabere do 10 minut a pomůže se zkoumáním dlouhodobých dopadů nemoci na kvalitu života pacientů.
              Děkujeme!
            </Typography>
          </Box>
        </Box>
      </Container>

      <Box mt={4} py={4} bgcolor='#D4F3EA54'>
        <Container maxWidth="md">
          <Typography variant="h3">
            O průzkumu
          </Typography>

          <Title>
            Postcovidový syndrom - tzv. long covid
          </Title>
          <Paragraph>
            Post-COVID syndrom je definován přítomností příznaků onemocnění COVID-19, které se objeví nebo pokračují po
            více než 12 týdnech od propuknutí nemoci a nejsou vysvětlitelné jinou diagnózou. Obvykle se jedná o skupiny
            příznaků proměnlivých v čase postihujících mnohočetné orgánové systémy. Mnoho pacientů s post-COVID
            syndromem trpí celkovými bolestmi, únavou, dlouhodobými horečkami a psychickými problémy.
          </Paragraph>
          <Paragraph>
            Aktuální zahraniční studie ukazují, že tímto syndromem trpí mezi 10 až 20% pacientů s prodělaným COVID-19.
            Nedávná britská studie ukázala, že v UK se jedná celkem o 1,1 mil. osob, v ČR by se tedy dalo předpokládat
            asi 250 tis. pacientů.
          </Paragraph>

          <Title>
            Co bude s posbíranými daty?
          </Title>
          <Paragraph>
            V České republice zatím neproběhl rozsáhlý výzkum, který by popisoval typ a frekvenci dlouhodobých příznaků
            a obtíží u pacientů, kteří prodělali COVID-19. Cílem tohoto průzkumu je sebrat dostatek dat, aby bylo možné
            podrobně popsat charakteristiky příznaků a obtíží spojených s postcovidovým syndromem u pacientů v České
            republice.
          </Paragraph>

          <Title>
            Kdo za průzkumem stojí
          </Title>
          <Paragraph>
            Za průzkumem stojí MUDr. Tomáš Doležal a lékařský tým platformy Medevio.
          </Paragraph>
          <Box my={2} display='flex' justifyContent='center' alignItems='center'>
            <Box display='flex' alignItems='center'>
              <img src='/tomas.png' alt='MUDr. Tomáš Doležal'/>
              <Box ml={5} mr={1}>
                <SvgIcon component="object">
                  <embed type="image/svg+xml" src="/favicon.svg" width="24"/>
                </SvgIcon>
              </Box>
              <Typography variant="h3">
                <LinkMUI href="https://medevio.cz/" underline="hover" color="textPrimary">
                  MEDEVIO
                </LinkMUI>
              </Typography>
            </Box>
          </Box>
          <Box display='flex' justifyContent='center'>
            <Typography variant='body2'>
              &copy; Medevio 2022
            </Typography>
          </Box>
        </Container>
      </Box>
    </>
  )
}
